import { apiGetCardSensitive } from '@shared-core/features/backend'
import { useCallback, useEffect, useState } from 'react'

export type CardCredentials = { number: string; expiry: string; cvc: string }

export function useCardCredentials(cardId: string) {
  const [isHidden, setIsHidden] = useState(true)
  const [credentials, setCredentials] = useState<CardCredentials | null>(null)
  const isLoading = !isHidden && !credentials

  // Полные реквизиты запрашиваем только после нажатия «Показать».
  useEffect(() => {
    if (isHidden || credentials) return

    let active = true
    const controller = new AbortController()

    // При ошибке возвращаем маску, чтобы пользователь мог повторить запрос.
    void apiGetCardSensitive({ routeParams: { id: cardId }, signal: controller.signal })
      .then((response) => {
        if (!active) return

        if (response?.status !== 'ok' || !response.data) {
          setIsHidden(true)
          return
        }

        const card = response.data
        setCredentials({
          number: card.number.replace(/(.{4})/g, '$1 ').trim(),
          expiry: card.expiryDate ?? '—',
          cvc: card.cvv,
        })
      })
      .catch(() => {
        if (active) setIsHidden(true)
      })

    return () => {
      active = false
      controller.abort()
    }
  }, [cardId, credentials, isHidden])

  const toggleHidden = useCallback(() => setIsHidden((value) => !value), [])

  return { credentials, isHidden, isLoading, toggleHidden }
}
